<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
    <path
      d="M13.0254 7.40039V6.15039C13.0254 3.49874 13.0254 2.17291 12.1101 1.34915C11.1948 0.525391 9.72167 0.525391 6.77539 0.525391C3.82911 0.525391 2.35597 0.525391 1.44068 1.34915C0.525391 2.17291 0.525391 3.49874 0.525391 6.15039V7.40039C0.525391 10.052 0.525391 11.3779 1.44068 12.2016C2.35597 13.0254 3.82911 13.0254 6.77539 13.0254C9.72167 13.0254 11.1948 13.0254 12.1101 12.2016C13.0254 11.3779 13.0254 10.052 13.0254 7.40039Z"
      stroke="currentColor"
      stroke-width="1.05"
    />
    <path
      d="M10.7224 4.14391H8.09082M9.40661 2.82812L9.40661 5.4597"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.7224 10.3945H8.09082"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.7224 8.41992H8.09082"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.45888 10.3944L4.30757 9.24311M4.30757 9.24311L3.15625 8.0918M4.30757 9.24311L5.45888 8.0918M4.30757 9.24311L3.15625 10.3944"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.4597 4.14453H2.82812"
      stroke="currentColor"
      stroke-width="1.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
